import { memo } from 'react'
import { SxProps } from '@mui/material'
import { useTranslations } from '@/core/translation'
import { Box, Container } from '@/components/Layout'
import { Text } from '@/components/Data'
import { ActionButtons } from '@/components/Inputs'
import { BackAndForwardButtons } from '@/components/Composed'
import { layoutWithSummaryStyles as styles } from './LayoutWithSummary.style'
import { LayoutWithSummaryProps } from './LayoutWithSummary.types'
import SummarySidebar from './SummarySidebar'

function LayoutWithSummary({
  heading,
  subHeading,
  actionsButtonsProps,
  children,
  includeAddons = false,
  hideSummaryInMobile = false,
  hideBackButton = false,
}: LayoutWithSummaryProps) {
  const t = useTranslations('general')

  return (
    <Container sx={styles.mainContainer} component={'section'}>
      <Container fixed sx={styles.container}>
        <Box sx={styles.contentWrapper}>
          {!hideBackButton && <BackAndForwardButtons hideSkipButton />}
          {(heading || subHeading) && (
            <Box
              sx={
                [
                  styles.headingsWrapper,
                  !subHeading && styles.headingsWrapperNoSubHeading,
                ] as SxProps
              }>
              {heading && (
                <Text sx={styles.heading} component={'h2'}>
                  {heading}
                </Text>
              )}
              {subHeading && <Text sx={styles.subHeading}>{subHeading}</Text>}
            </Box>
          )}
          {children}
          <ActionButtons
            primaryActionText={t('continue')}
            secondaryActionText={t('skipExtras')}
            bordered
            fixedInMobile
            largePrimaryButton
            {...actionsButtonsProps}
          />
        </Box>
        <Box sx={styles.summaryWrapper}>
          <SummarySidebar {...{ includeAddons, hideInMobile: hideSummaryInMobile }} />
        </Box>
      </Container>
    </Container>
  )
}

export default memo(LayoutWithSummary)
